import './Branding.scss';
import React from 'react';
import {Link} from "react-router-dom";

const Branding: React.FC = () => {
  return (
    <Link to="/home" className="flex items-center">
      <div className="w-36 h-16 mr-2 relative">
        <div className="absolute inset flex items-center justify-center">
          <div className="logo-icon h-16 w-36"
               // dangerouslySetInnerHTML={{__html: getLogoContent()}}
          >
            {/*<img src="images/logo.svg" alt="Logo" className="w-36 h-full"/>*/}
            {/*<img src="images/logo-colorful.svg" alt="Logo"/>*/}
            <img src="/images/logo-white.svg" alt="Logo"/>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default Branding;
